var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"cols":_vm.cols}},[_c('b-form-group',{attrs:{"label":_vm.label}},[(!_vm.is_loading)?_vm._t("default"):_c('b-skeleton',{attrs:{"type":"input","width":"100%"}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }